import { ShieldCheck, MicrosoftOutlookLogo, HardDrives, WifiHigh, Shield, MonitorPlay, FileText, ClipboardText, Clock } from "@phosphor-icons/react";

const VALIDITY_OPTIONS = [
  { v: "12", l: "12 mesi" },
  { v: "24", l: "24 mesi" },
  { v: "36", l: "36 mesi" },
  { v: "lifetime", l: "A vita" },
];

const validityLabel = (v) => (VALIDITY_OPTIONS.find((o) => o.v === v)?.l || v);

export const MODULES_REGISTRY = [
  {
    id: "antivirus-license",
    to: "/moduli/antivirus-license",
    title: "Licenza Antivirus",
    description: "Documento di consegna licenza antivirus (product key, dispositivi, durata).",
    icon: ShieldCheck,
    category: "Licenza",
    keywords: ["antivirus", "kaspersky", "bitdefender", "eset", "norton", "chiave"],
    endpoint: "/modules/antivirus-license/pdf",
    filenamePrefix: "licenza-antivirus",
    subtitle: "Documento di consegna licenza software",
    defaults: { devices_count: "1", duration_months: "12" },
    fields: [
      { key: "antivirus_type", label: "Tipo antivirus", type: "text", required: true, placeholder: "Es. Kaspersky Standard 2026", colSpan: 2 },
      { key: "product_key", label: "Product Key", type: "text", required: true, mono: true, placeholder: "XXXX-XXXX-XXXX-XXXX", colSpan: 2 },
      { key: "devices_count", label: "Dispositivi coperti", type: "number", required: true },
      { key: "duration_months", label: "Durata (mesi)", type: "number", required: true },
    ],
    emailSubject: (c) => `Licenza Antivirus - Diotech`,
    emailBody: (c) => `Gentile ${c.surname} ${c.name},\n\nin allegato trova la licenza antivirus attivata.`,
  },
  {
    id: "office-license",
    to: "/moduli/office-license",
    title: "Licenza Microsoft Office",
    description: "Consegna licenza pacchetto Office (product key, validità, postazioni).",
    icon: MicrosoftOutlookLogo,
    category: "Licenza",
    keywords: ["office", "microsoft", "word", "excel", "365", "postazioni"],
    endpoint: "/modules/office-license/pdf",
    filenamePrefix: "licenza-office",
    subtitle: "Documento di consegna licenza software",
    defaults: { validity: "12" },
    fields: [
      { key: "office_type", label: "Tipo pacchetto Office", type: "text", required: true, placeholder: "Es. Microsoft 365 Family, Office Home & Business 2024", colSpan: 2 },
      { key: "product_key", label: "Product Key", type: "text", required: true, mono: true, placeholder: "XXXXX-XXXXX-XXXXX-XXXXX-XXXXX", colSpan: 2 },
      { key: "validity", label: "Validità", type: "select", required: true, options: VALIDITY_OPTIONS },
      { key: "workstations", label: "Postazioni", type: "number", required: false, help: "Numero postazioni coperte" },
    ],
    emailSubject: () => "Licenza Microsoft Office - Diotech",
    emailBody: (c) => `Gentile ${c.surname} ${c.name},\n\nin allegato trova la licenza Microsoft Office attivata.`,
  },
  {
    id: "backup-license",
    to: "/moduli/backup-license",
    title: "Licenza Software Backup",
    description: "Consegna licenza software di backup (product key, validità, postazioni).",
    icon: HardDrives,
    category: "Licenza",
    keywords: ["backup", "acronis", "veeam", "salvataggio", "postazioni"],
    endpoint: "/modules/backup-license/pdf",
    filenamePrefix: "licenza-backup",
    subtitle: "Documento di consegna licenza software",
    defaults: { validity: "12" },
    fields: [
      { key: "software_name", label: "Software di backup", type: "text", required: true, placeholder: "Es. Acronis Cyber Protect, Veeam Backup", colSpan: 2 },
      { key: "product_key", label: "Product Key", type: "text", required: true, mono: true, colSpan: 2 },
      { key: "validity", label: "Validità", type: "select", required: true, options: VALIDITY_OPTIONS },
      { key: "workstations", label: "Postazioni", type: "number", required: false, help: "Numero postazioni coperte" },
    ],
    emailSubject: () => "Licenza Software Backup - Diotech",
    emailBody: (c) => `Gentile ${c.surname} ${c.name},\n\nin allegato trova la licenza del software di backup attivata.`,
  },
  {
    id: "wifi-network",
    to: "/moduli/wifi-network",
    title: "Rete Wireless",
    description: "Consegna credenziali rete Wi-Fi e apparato (SSID, password, admin, gateway).",
    icon: WifiHigh,
    category: "Rete",
    keywords: ["wifi", "wireless", "ssid", "router", "access point", "gateway"],
    endpoint: "/modules/wifi-network/pdf",
    filenamePrefix: "rete-wifi",
    subtitle: "Credenziali di rete Wi-Fi e apparato",
    defaults: {},
    fields: [
      { key: "ssid", label: "SSID (nome rete)", type: "text", required: true, placeholder: "Es. Diotech-WiFi" },
      { key: "wifi_key", label: "Password Wi-Fi", type: "text", required: true, mono: true },
      { key: "admin_user", label: "Utente admin router", type: "text", required: false },
      { key: "admin_password", label: "Password admin router", type: "text", required: false, mono: true },
      { key: "gateway", label: "Gateway / IP router", type: "text", required: false, mono: true, placeholder: "192.168.1.1" },
      { key: "notes", label: "Note", type: "textarea", required: false, colSpan: 2 },
    ],
    emailSubject: () => "Credenziali Rete Wireless - Diotech",
    emailBody: (c) => `Gentile ${c.surname} ${c.name},\n\nin allegato trova le credenziali della rete wireless configurata.`,
  },
  {
    id: "firewall",
    to: "/moduli/firewall",
    title: "Firewall",
    description: "Consegna credenziali firewall (utente, password, IP, note).",
    icon: Shield,
    category: "Rete",
    keywords: ["firewall", "sicurezza", "sophos", "fortinet", "pfsense"],
    endpoint: "/modules/firewall/pdf",
    filenamePrefix: "firewall",
    subtitle: "Credenziali di accesso apparato",
    defaults: {},
    fields: [
      { key: "admin_user", label: "Utente admin", type: "text", required: true },
      { key: "admin_password", label: "Password admin", type: "text", required: true, mono: true },
      { key: "ip_address", label: "Indirizzo IP", type: "text", required: true, mono: true, placeholder: "192.168.1.1" },
      { key: "notes", label: "Note", type: "textarea", required: false, colSpan: 2 },
    ],
    emailSubject: () => "Configurazione Firewall - Diotech",
    emailBody: (c) => `Gentile ${c.surname} ${c.name},\n\nin allegato trova le credenziali del firewall configurato.`,
  },
  {
    id: "nvr",
    to: "/moduli/nvr",
    title: "NVR / Videosorveglianza",
    description: "Consegna credenziali NVR videoregistratore (utente, password, IP, DDNS, modello).",
    icon: MonitorPlay,
    category: "Rete",
    keywords: ["nvr", "dvr", "videosorveglianza", "telecamere", "hikvision", "dahua"],
    endpoint: "/modules/nvr/pdf",
    filenamePrefix: "nvr",
    subtitle: "Credenziali di accesso videoregistratore",
    defaults: {},
    fields: [
      { key: "model", label: "Modello NVR", type: "text", required: false, placeholder: "Es. Hikvision DS-7616", colSpan: 2 },
      { key: "admin_user", label: "Utente admin", type: "text", required: true },
      { key: "admin_password", label: "Password admin", type: "text", required: true, mono: true },
      { key: "ip_address", label: "Indirizzo IP", type: "text", required: true, mono: true, placeholder: "192.168.1.100" },
      { key: "public_key", label: "Chiave pubblica / DDNS", type: "text", required: false, mono: true, help: "Es. mio-nvr.ddns.net o token API" },
    ],
    emailSubject: () => "Configurazione NVR - Diotech",
    emailBody: (c) => `Gentile ${c.surname} ${c.name},\n\nin allegato trova le credenziali dell'NVR configurato.`,
  },
  // ---------- Custom modules (dedicated pages) ----------
  {
    id: "intervention-report",
    to: "/moduli/intervention-report",
    title: "Verbale Intervento",
    description: "Descrizione libera di un intervento (oggetto + testo esteso).",
    icon: FileText,
    category: "Documento",
    keywords: ["verbale", "intervento", "relazione"],
    custom: true,
  },
  {
    id: "checkup",
    to: "/moduli/checkup",
    title: "Check-up Iniziale",
    description: "Scheda di analisi infrastruttura IT con sezioni (compilabile o stampabile in bianco).",
    icon: ClipboardText,
    category: "Documento",
    keywords: ["checkup", "analisi", "audit", "questionario", "prima visita"],
    custom: true,
  },
  {
    id: "minute-package-report",
    to: "/moduli/minute-package-report",
    title: "Riepilogo Pacchetto Minuti",
    description: "Situazione minuti residui + elenco interventi registrati per il cliente.",
    icon: Clock,
    category: "Report",
    keywords: ["pacchetto", "minuti", "riepilogo", "ore", "monte ore"],
    custom: true,
  },
];

export { validityLabel };
